/**
 * Created by claudio iozzia on 04/05/2017.
 */
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Ic, IEntityAlert, ITranslatedObj} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {EntityError} from "../../../../models/EntityAlert";
import {Utils} from "../../../../common/utils";
import {currentBoundFromPower, minPFCVout, roundToEffectiveValue} from "../../../../models/utils_specs";
import {Validator_Common} from "../../../../models/validator/validator_common";

export class Validator_AcDc_PFC_Boost extends Validator_Common {

  private validatorFn_SingleOutput_Voltage_PFC_BOOST: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const maxInput: number = (spec.spec.value.input) && Utils.isValueReal(spec.spec.value.input.max) ? spec.spec.value.input.max : NaN;
    const _minPFCVout: number = "stnrgpf01" === a.CPN.toLowerCase()
      ? minPFCVout(maxInput, 0.07)
      : minPFCVout(maxInput, 0.05);

    const voutMin: number = Utils.isValueReal(_minPFCVout) ? Math.max(a.vout_min, _minPFCVout) : a.vout_min;
    const _vOut = spec.spec.value.output.outputs[o].voltage;
    const result = Utils.acceptInRange(_vOut, voutMin, a.vout_max, "Vout", "V");
    return new EntityError(result);
  }

  private validatorFn_SingleOutput_Current_PFC_BOOST: ValidatorOutputFn = (a: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    let result: ITranslatedObj = null;
    const _iOut = spec.spec.value.output.outputs[o].current;
    const bound = currentBoundFromPower(a, spec.spec.value.output.outputs[o]);
    result = Utils.acceptInRange(_iOut, bound.min, bound.max, "Iout", "A");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_PFC_BOOST].concat(super.singleOutputV());
  }

  protected singleOutputI(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Current_PFC_BOOST].concat(super.singleOutputI());
  }

}

